import { z } from "zod";

import { dateSchema } from './utils';

const predictionFundsActivitySchema = z.object({
  id: z.string(),
  amount: z.number(),
  transaction_type: z.enum(["DEPOSIT", "WITHDRAW", "REFUND"]),
  payment_method_type: z.enum(["ach", "card"]),
  last_four: z.string(),
  description: z.string(),
  created_at: dateSchema,
});

type PredictionFundsActivity = z.infer<typeof predictionFundsActivitySchema>;

export { predictionFundsActivitySchema, type PredictionFundsActivity };
